<script>
import GroupIndex from "../../../abstract/GroupIndex.js";

export default GroupIndex.extend({
  data() {
    return {
      type: "optional",
    };
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/groups/optional/Index.vue